const fakeIncome = [
  {
    _id: "689fa84a5f7ce3012f93bfa1",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.784512,
          longitude: -63.180231,
        },
        street: "Calle Libertad #102, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c1234dab0173b9b7a0cc2",
      name: "Sucursal Centro",
    },
    type: "Ingreso",
    employee: {
      _id: "65fabc7e8247b801aa98fd03",
      fullName: "María Eugenia Ríos",
      phone: "76912345",
      photoURL: "https://te-ayudo-img.s3.us-east-2.amazonaws.com/test/users/maria-fake-photo.png",
      CI: "8845123",
      location: [],
    },
    description: "Servicio de depilación",
    amount: 120,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-05-30T09:15:00.000Z",
    createdAt: "2025-05-30T09:15:00.000Z",
    updatedAt: "2025-05-30T09:15:00.000Z",
    __v: 0,
    id: "689fa84a5f7ce3012f93bfa1",
  },
  {
    _id: "689fa8575f7ce3012f93bfa2",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.812345,
          longitude: -63.190222,
        },
        street: "Av. Roca y Coronado, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c4321dab0173b9b7a0dd3",
      name: "Sucursal Roca",
    },
    type: "Ingreso",
    employee: {
      location: [],
    },
    description: "Venta de shampoo orgánico",
    amount: 75,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-01T13:20:00.000Z",
    createdAt: "2025-06-01T13:20:00.000Z",
    updatedAt: "2025-06-01T13:20:00.000Z",
    __v: 0,
    id: "689fa8575f7ce3012f93bfa2",
  },
  {
    _id: "689fa8615f7ce3012f93bfa3",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.805678,
          longitude: -63.215789,
        },
        street: "Av. Banzer 4to Anillo, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649c8765dab0173b9b7a0ee4",
      name: "Sucursal Norte",
    },
    employee: {
      location: [],
    },
    type: "Ingreso",
    description: "Cobro por servicio de limpieza facial",
    amount: 200,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-02T17:45:00.000Z",
    createdAt: "2025-06-02T17:45:00.000Z",
    updatedAt: "2025-06-02T17:45:00.000Z",
    __v: 0,
    id: "689fa8615f7ce3012f93bfa3",
  },
  {
    _id: "689fa86c5f7ce3012f93bfa4",
    branch: {
      addressInfo: {
        coordinates: {
          latitude: -17.776543,
          longitude: -63.165321,
        },
        street: "Calle Warnes, Santa Cruz de la Sierra, Bolivia",
      },
      _id: "649cb321dab0173b9b7a0ff5",
      name: "Sucursal Sur",
    },
    type: "Ingreso",
    employee: {
      _id: "65fabc7e8247b801aa98fd04",
      phone: "71234567",
      pushToken: null,
      location: [],
    },
    description: "Comisión por paquete estético",
    amount: 310,
    provider: "5e6b31a018048974ea17f435",
    date: "2025-06-05T11:00:00.000Z",
    createdAt: "2025-06-05T11:00:00.000Z",
    updatedAt: "2025-06-05T11:00:00.000Z",
    __v: 0,
    id: "689fa86c5f7ce3012f93bfa4",
  },
];

export default fakeIncome;
